import NiceModal from '@ebay/nice-modal-react';

import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import Icon from 'components/global/Icon';
import Tooltip from 'components/global/Tooltip';
import Typography from 'components/global/Typography';

import OTOLinkStatusesModal from 'pages/Shipments/ActionForms/OTOLinkStatusesModal';
import OrderStatusesModal from 'pages/Shipments/ActionForms/OrderStatusesModal';
import OtoOrderStatusHistoryModal from 'pages/Shipments/ActionForms/OtoOrderStatusHistoryModal';
import TransactionStatusesModal from 'pages/Shipments/ActionForms/TransactionStatusesModal';

import {
	faArrowRotateLeft,
	faArrowUpArrowDown,
	faBackward,
	faBadgeCheck,
	faBagShopping,
	faBan,
	faBarsProgress,
	faCheckCircle,
	faCircleCheck,
	faCircleExclamationCheck,
	faCircleQuestion,
	faCircleUp,
	faCircleXmark,
	faClock,
	faCreditCard,
	faDolly,
	faDownload,
	faEquals,
	faFileCheck,
	faFire,
	faHourglassClock,
	faHourglassEnd,
	faLoader,
	faLocationCheck,
	faLocationDot,
	faMagnifyingGlassLocation,
	faMapLocationDot,
	faMoneyBillTransfer,
	faMoon,
	faPaperPlane,
	faPeopleCarryBox,
	faPersonWalking,
	faRightLeft,
	faSackDollar,
	faShop,
	faShopSlash,
	faSpaceShuttle,
	faSquareXmark,
	faTriangleExclamation,
	faTruck,
	faTruckClock,
	faTruckRampBox,
	faUpload,
	faUserCheck,
	faVial,
	faWallet,
	faWarehouse,
	faWarehouseFull,
	faXmarkToSlot
} from '@fortawesome/pro-regular-svg-icons';

import * as S from './styled/Status.styled';

/**
 * @author @buunsal
 */

export const StatusConfig = {
	new: { icon: faFire, color: 'blue' },
	waitingAssignment: { icon: faMapLocationDot, color: 'blue' },
	assignedToWarehouse: { icon: faWarehouse, color: 'teel' },
	branchAssigned: { icon: faShop, color: 'blue' },
	shipmentCanceled: { icon: faCircleXmark, color: 'red' },
	shipmentCancelled: { icon: faCircleXmark, color: 'red' },
	reverseShipmentCanceled: { icon: faCircleXmark, color: 'red' },
	shipmentCreated: { icon: faDolly, color: 'green' },
	reverseShipmentCreated: { icon: faBackward, color: 'green' },
	searchingDriver: { icon: faMagnifyingGlassLocation, color: 'yellow' },
	goingToPickup: { icon: faPersonWalking, color: 'yellow' },
	reverseGoingToPickup: { icon: faPersonWalking, color: 'yellow' },
	pickedUp: { icon: faPeopleCarryBox, color: 'green' },
	reversePickedUp: { icon: faBackward, color: 'teel' },
	outForDelivery: { icon: faTruck, color: 'green' },
	reverseOutForDelivery: { icon: faBackward, color: 'green' },
	undeliveredAttempt: { icon: faTriangleExclamation, color: 'yellow' },
	reverseUndeliveredAttempt: { icon: faSquareXmark, color: 'yellow' },
	delivered: { icon: faFileCheck, color: 'green' },
	canceled: { icon: faCircleXmark, color: 'red' },
	cancelled: { icon: faCircleXmark, color: 'red' },
	destroyed: { icon: faTriangleExclamation, color: 'red' },
	returnDestroyed: { icon: faBackward, color: 'green' },
	heldAtCustomsClearance: { icon: faHourglassClock, color: 'yellow' },
	reverseHeldAtCustomsClearance: { icon: faBackward, color: 'yellow' },
	moreDocumentsRequired: { icon: faHourglassClock, color: 'yellow' },
	reverseMoreDocumentsRequired: { icon: faBackward, color: 'yellow' },
	returned: { icon: faArrowRotateLeft, color: 'yellow' },
	reverseReturned: { icon: faBackward, color: 'yellow' },
	confirmed: { icon: faCircleCheck, color: 'green' },
	confirmedReturn: { icon: faCircleCheck, color: 'green' },
	reverseConfirmReturn: { icon: faBackward, color: 'green' },
	active: { icon: faCircleCheck, color: 'green' },
	testMode: { icon: faVial, color: 'teel' },
	test: { icon: faVial, color: 'teel' },
	inactive: { icon: faCircleXmark, color: 'red' },
	passive: { icon: faCircleXmark, color: 'red' },
	notYet: { icon: faCircleXmark, color: 'blue' },
	yes: { icon: faCircleCheck, color: 'green' },
	Yes: { icon: faCircleCheck, color: 'green' },
	no: { icon: faCircleXmark, color: 'red' },
	No: { icon: faCircleXmark, color: 'red' },
	onDuty: { icon: faSpaceShuttle, color: 'blue' },
	notOnDuty: { icon: faMoon, color: 'yellow' },
	failed: { icon: faCircleXmark, color: 'red' },
	success: { icon: faCircleCheck, color: 'green' },
	true: { icon: faCircleCheck, color: 'green' },
	false: { icon: faCircleXmark, color: 'red' },
	completed: { icon: faCircleCheck, color: 'green' },
	refunded: { icon: faCircleCheck, color: 'green' },
	booked: { icon: faCircleExclamationCheck, color: 'blue' },
	pending: { icon: faClock, color: 'yellow' },
	invited: { icon: faPaperPlane, color: 'yellow' },
	smsSentToReceiver: { icon: faPaperPlane, color: 'teel' },
	paid: { icon: faSackDollar, color: 'green' },
	cod: { icon: faSackDollar, color: 'teel' },
	rejected: { icon: faXmarkToSlot, color: 'red' },
	arrivedDestinationTerminal: { icon: faWarehouseFull, color: 'green' },
	inTransit: { icon: faTruckClock, color: 'blue' },
	departedTerminal: { icon: faTruckClock, color: 'teel' },
	reverseDepartedTerminal: { icon: faBackward, color: 'teel' },
	shipmentOnHold: { icon: faHourglassClock, color: 'yellow' },
	reverseShipmentOnHold: { icon: faHourglassClock, color: 'yellow' },
	returnProcessing: { icon: faArrowRotateLeft, color: 'yellow' },
	processing: { icon: faArrowRotateLeft, color: 'yellow' },
	shipmentOnHoldWarehouse: { icon: faHourglassClock, color: 'blue' },
	arrivedPickup: { icon: faTruckRampBox, color: 'green' },
	shipmentOnHoldToCancel: { icon: faSquareXmark, color: 'red' },
	paymentConfirmed: { icon: faBadgeCheck, color: 'green' },
	addressConfirmed: { icon: faLocationCheck, color: 'green' },
	waitingAddressConfirmation: { icon: faLocationDot, color: 'yellow' },
	needConfirmation: { icon: faTriangleExclamation, color: 'yellow' },
	notAvailable: {
		icon: faBan,
		color: 'black',
		textColor: 'var(--black-40)',
		borderColor: 'var(--black-30)',
		bgColor: 'var(--background-3)'
	},
	approved: { icon: faCircleCheck, color: 'green' },
	submitted: { icon: faBadgeCheck, color: 'green' },
	arrivedDestination: { icon: faMapLocationDot, color: 'teel' },
	arrivedOriginTerminal: { icon: faMapLocationDot, color: 'teel' },
	arrivedTerminal: { icon: faMapLocationDot, color: 'teel' },
	reverseArrivedTerminal: { icon: faBackward, color: 'teel' },
	reverseArrivedDestinationTerminal: { icon: faBackward, color: 'teel' },
	assigned: { icon: faUserCheck, color: 'green' },
	interDepotTransfer: { icon: faRightLeft, color: 'blue' },
	returnShipmentProcessing: { icon: faBackward, color: 'yellow' },
	shipmentInProgress: { icon: faTruck, color: 'teel' },
	cannotAssignToBranch: { icon: faShopSlash, color: 'red' },
	inprogress: { icon: faBarsProgress, color: 'blue' },
	partiallyCompleted: { icon: faBarsProgress, color: 'green' },
	pickupFromStore: { icon: faBagShopping, color: 'yellow' },
	readyForCollection: { icon: faCheckCircle, color: 'teel' },
	waitingReturnShipment: { icon: faTruckClock, color: 'yellow' },
	waitingApproval: { icon: faClock, color: 'yellow' },
	paymentTypeConfirmed: { icon: faBadgeCheck, color: 'green' },
	codOrderConfirmed: { icon: faBadgeCheck, color: 'green' },
	notAvailableWH: {
		icon: faShopSlash,
		color: 'black',
		textColor: 'var(--black-40)',
		borderColor: 'var(--black-30)',
		bgColor: 'var(--background-3)'
	},
	notAvailableBR: {
		icon: faShopSlash,
		color: 'black',
		textColor: 'var(--black-40)',
		borderColor: 'var(--black-30)',
		bgColor: 'var(--background-3)'
	},
	blocked: { icon: faBan, color: 'red' },
	referredStage1: { icon: faCircleCheck, color: 'blue' },
	referredStage2: { icon: faBagShopping, color: 'blue' },
	Granted: { icon: faCheckCircle, color: 'green' },
	Expired: { icon: faHourglassEnd, color: 'red' },
	expired: { icon: faHourglassEnd, color: 'red' },
	locationsFound: { icon: faCheckCircle, color: 'green' },
	conditionsNotSatisfied: { icon: faCircleXmark, color: 'red' },
	noLocationHasFound: { icon: faCircleXmark, color: 'red' },
	needParameterCheck: { icon: faCircleUp, color: 'blue' },
	bookedCanceled: { icon: faCircleXmark, color: 'red' },
	bookedReturned: { icon: faArrowRotateLeft, color: 'yellow' },
	revoked: { icon: faCircleXmark, color: 'red' },
	lostOrDamaged: { icon: faTriangleExclamation, color: 'red' },
	lost: { icon: faTriangleExclamation, color: 'red' },
	wrongDelivery: { icon: faTriangleExclamation, color: 'red' },
	page: { color: 'blue' },
	action: { color: 'green' },
	'importStatus.failed': { icon: faCircleXmark, color: 'red' },
	'importStatus.pending': { icon: faLoader, color: 'yellow' },
	'importStatus.processing': { icon: faLoader, color: 'yellow' },
	'importStatus.partially': { icon: faCircleQuestion, color: 'yellow' },
	'importStatus.completed': { icon: faCircleCheck, color: 'green' },
	'exportStatus.failed': { icon: faCircleXmark, color: 'red' },
	'exportStatus.pending': { icon: faLoader, color: 'yellow' },
	'exportStatus.completed': { icon: faDownload, color: 'green' },
	reconciled: { icon: faEquals, color: 'green' },
	priceNotFound: { icon: faCircleXmark, color: 'red' },
	// Invoice checker statuses
	noDifference: { icon: faCircleCheck, color: 'green' },
	dontCharge: { icon: faCircleCheck, color: 'green' },
	chargedAndCompleted: { icon: faCircleCheck, color: 'green' },
	pendingUndercharge: { icon: faClock, color: 'yellow' },
	pendingOvercharge: { icon: faClock, color: 'yellow' },
	newReport: { icon: faFire, color: 'blue' },
	otoCredit: { icon: faCreditCard, color: 'teel' },
	cashDeposited: { icon: faWallet, color: 'green' },
	codWallet: { icon: faWallet, color: 'blue' },
	bankTransferRequest: { icon: faClock, color: 'yellow' },
	unpaid: { icon: faCircleXmark, color: 'red' },
	orderAddressIsNotValid: { icon: faCircleXmark, color: 'red' },
	returnReverseComment: { icon: faBackward, color: 'yellow' },
	deleted: { icon: faBan, color: 'red' },
	orderConfirmed: { icon: faCircleCheck, color: 'green' },
	noConflict: { icon: faArrowUpArrowDown, color: 'blue' },
	received: { icon: faCircleCheck, color: 'green' },
	manuallyCompleted: { icon: faCircleCheck, color: 'green' },
	pendingCancel: { icon: faClock, color: 'yellow' },
	missingData: { icon: faBan, color: 'red' },
	partiallycompleted: { icon: faBarsProgress, color: 'green' },
	pickupLocationClosed: {
		icon: faCircleXmark,
		color: 'black',
		textColor: 'var(--black-40)',
		borderColor: 'var(--black-30)',
		bgColor: 'var(--background-3)'
	},
	pickupLocationOpen: { icon: faCircleCheck, color: 'green' },
	waitingCustomerConfirmation: { icon: faClock, color: 'yellow' },
	confirmedAndScheduled: { icon: faCircleCheck, color: 'green' },
	confirmationCanceled: { icon: faCircleXmark, color: 'red' },
	confirmationFailed: { icon: faCircleXmark, color: 'red' },
	scheduledShipmentFailed: { icon: faCircleXmark, color: 'red' },
	noActiveWorkingHours: {
		icon: faCircleXmark,
		color: 'black',
		textColor: 'var(--black-40)',
		borderColor: 'var(--black-30)',
		bgColor: 'var(--background-3)'
	},
	heldForPickup: { icon: faHourglassClock, color: 'yellow' },
	reverseHeldForPickup: { icon: faBackward, color: 'yellow' },
	reverseShipment: { icon: faCircleCheck, color: 'green' },
	failedDelivery: { icon: faCircleXmark, color: 'red' },
	checkoutCompleted: { icon: faCircleCheck, color: 'green' },
	contactFilled: { icon: faUserCheck, color: 'yellow' },
	awaitingBuyerConfirmation: { icon: faClock, color: 'yellow' },
	paymentReleased: { icon: faSackDollar, color: 'green' },
	autoPaymentReleased: {
		icon: faHourglassClock,
		color: 'black',
		textColor: 'var(--black-40)',
		borderColor: 'var(--black-30)',
		bgColor: 'var(--background-3)'
	},
	paymentFailed: { icon: faCircleXmark, color: 'red' },
	shippingSelected: { icon: faTruck, color: 'teel' },
	notApprovedDocuments: { icon: faCircleXmark, color: 'red' },
	notApprovedBusiness: { icon: faCircleXmark, color: 'red' },
	pickupAttempted: { icon: faTriangleExclamation, color: 'yellow' },
	reversePickupAttempted: { icon: faTriangleExclamation, color: 'yellow' },
	driverAssigned: { icon: faPersonWalking, color: 'teel' },
	partiallyDelivered: { icon: faFileCheck, color: 'green' },
	noInsertStatus: { icon: faUpload, color: 'yellow' },
	addressChanged: { icon: faLocationDot, color: 'teel' },
	informationUpdate: { icon: faFileCheck, color: 'teel' },
	deducted: { icon: faMoneyBillTransfer, color: 'yellow' }
};

const Status = ({ value, prefix, ...props }) => {
	const data = useMemo(() => StatusConfig[value], [value]);

	return data ? (
		<S.Container
			className="status"
			style={{
				backgroundColor: data.bgColor ?? `var(--${data.color}-10)`,
				color: data.textColor ?? `var(--${data.color})`,
				borderColor: data.borderColor ?? `var(--${data.color}-60)`,
				...props.style
			}}>
			{data.icon && <Icon fontSize="1.5rem" icon={data.icon} color={data.textColor ?? `var(--${data.color})`} />}
			{value && <Typography fontWeight="500">{`status.${prefix ?? ''}${value}`}</Typography>}
		</S.Container>
	) : (
		value && <Typography fontWeight="500">{`status.${prefix ?? ''}${value}`}</Typography>
	);
};

export const ShipmentStatus = (props) => {
	const { prefix, value, renderCellProps, data, statusHistoryApi } = props;
	const { t } = useTranslation();

	const tooltipKey = `tooltip.status.${prefix ?? ''}${value}`;
	const tooltipTitle = t(tooltipKey) !== tooltipKey ? tooltipKey : 'shipmentStatusButtonTooltip';

	return (
		<Tooltip title={tooltipTitle} showOnMobile={false}>
			<S.ShipmentStatusButton
				fullWidth
				variant="borderless"
				onClick={() =>
					NiceModal.show(OrderStatusesModal, {
						ID: data[renderCellProps?.ID ?? 'ID'],
						orderID: data[renderCellProps?.orderID ?? 'orderID'],
						shipmentNumber: data[renderCellProps?.shipmentNumber ?? 'shipmentNumber'],
						orderStatusApiSource: statusHistoryApi
					})
				}>
				<Status {...props} />
			</S.ShipmentStatusButton>
		</Tooltip>
	);
};

export const OtoOrderStatusHistory = (props) => {
	const { prefix, value, data } = props;
	const { t } = useTranslation();

	const tooltipKey = `tooltip.status.${prefix ?? ''}${value}`;
	const tooltipTitle = t(tooltipKey) !== tooltipKey ? tooltipKey : 'shipmentStatusButtonTooltip';

	return (
		<Tooltip title={tooltipTitle} showOnMobile={false}>
			<S.ShipmentStatusButton
				fullWidth
				variant="borderless"
				onClick={() =>
					NiceModal.show(OtoOrderStatusHistoryModal, {
						ID: data.otoOrderId
					})
				}>
				<Status {...props} />
			</S.ShipmentStatusButton>
		</Tooltip>
	);
};

export const TransactionStatus = (props) => (
	<Tooltip title="shipmentStatusButtonTooltip" showOnMobile={false}>
		<S.ShipmentStatusButton
			fullWidth
			variant="borderless"
			onClick={() =>
				NiceModal.show(TransactionStatusesModal, {
					ID: props.data.ID,
					CODWalletTransactionID: props.data.CODWalletTransactionID,
					props
				})
			}>
			<Status {...props} />
		</S.ShipmentStatusButton>
	</Tooltip>
);

export const OTOLinkSessionStatus = (props) => (
	<S.ShipmentStatusButton
		fullWidth
		variant="borderless"
		onClick={() =>
			NiceModal.show(OTOLinkStatusesModal, {
				sessionId: props.data.linkSessionId
			})
		}>
		<Status {...props} />
	</S.ShipmentStatusButton>
);

export default Status;
